import * as Err from '@fixtuur/error-context';
import * as Arr from 'fp-ts/Array';
import * as REA from 'fp-ts/ReadonlyArray';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import * as ApiParticle from '../../../api/configuration/particle';
export var FromParticleErrorMessage;
(function (FromParticleErrorMessage) {
    FromParticleErrorMessage["LoadingAttachments"] = "Error loading attachments";
})(FromParticleErrorMessage || (FromParticleErrorMessage = {}));
export const fromPartices = (serviceConfig, particles) => pipe(particles, Arr.map(particle => ApiParticle.Attachments.fromParticle(serviceConfig, particle)), TE.sequenceArray, TE.map(attachments => pipe(particles, Arr.map(p => p.id), Arr.zip(REA.toArray(attachments)))), TE.mapLeft(Err.swap(FromParticleErrorMessage.LoadingAttachments)));
